import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DefinitionRoutingModule } from './definition-routing.module';
import { HomeComponent } from './home/home.component';
import { AddComponent } from './add/add.component';
import { UpdateComponent } from './update/update.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [HomeComponent, AddComponent, UpdateComponent],
  imports: [
    CommonModule,
    DefinitionRoutingModule,
    MatFormFieldModule,
   ReactiveFormsModule,
    MatInputModule,
  ]
})
export class DefinitionModule { }
